module.exports = __webpack_public_path__ + "img/cumulative-sequences.1aaa8439.png";